import { SwalService } from './../../services/swal.service';
import { Component, OnInit, HostListener, Input, ElementRef, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-image-file-selector',
  templateUrl: './image-file-selector.component.html',
  styleUrls: ['./image-file-selector.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ImageFileSelectorComponent,
      multi: true,
    },
  ],
})
export class ImageFileSelectorComponent implements ControlValueAccessor {
  // onChange: Function;
  public file: File | null = null;
  isDisabled: boolean;
  onTouch = () => {};
  onChange = (_: any) => {};

  constructor(private host: ElementRef<HTMLInputElement>, private _swal: SwalService, private _renderer: Renderer2) {}

  @HostListener('change', ['$event.target.files']) emitFiles(event: FileList) {
    const file = event && event.item(0);
    console.log(file);
    // Si llega undefined o null
    if (file == undefined || file == null) {
      this.onChange(file);
      this.file = null;
    } else {
      // Si llega algo diferente a null y undefined se valida que sea una imagen
      if (this.imgValidation(file.type)) {
        if (this.sizeValidation(file.size)) {
          this.onChange(file);
          this.file = file;
        } else {
          this._swal.showErrorNotification('Debe ser menor a 2MB');
          this.file = null;
        }
      } else {
        this._swal.showErrorNotification('Sólo se aceptan los formatos: jpg, jpeg y png');
      }
    }
  }

  writeValue(value: null) {
    // clear file input
    this.host.nativeElement.value = '';
    this.file = null;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  imgValidation(imgType) {
    if (
      imgType === 'image/png' ||
      imgType === 'image/PNG' ||
      imgType === 'image/jpg' ||
      imgType === 'image/JPG' ||
      imgType === 'image/jpeg' ||
      imgType === 'image/JPEG'
    ) {
      return true;
    }
    return false;
  }

  sizeValidation(fileSize: number) {
    // 2 MB
    const maxSizeInBytes = 2e6;
    if (fileSize > maxSizeInBytes) {
      return false;
    }
    return true;
  }
}
